<div class="option-wrapper fx-row fx-v-align-center">
  <div class="option">{{ option?.name }}</div>
  <mat-icon class="remove-icon" (click)="deleteOption.next()">close</mat-icon>
</div>
